/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { SmsAddonFailureReasonEnumType } from "./SmsAddonFailureReasonEnum"
import { RootStoreType } from "./index"


/**
 * SmsAddonFailedDtoBase
 * auto generated base class for the model SmsAddonFailedDtoModel.
 */
export const SmsAddonFailedDtoModelBase = ModelBase
  .named('SmsAddonFailedDto')
  .props({
    __typename: types.optional(types.literal("SmsAddonFailedDto"), "SmsAddonFailedDto"),
    /** Correlation id from the originating subscribeSmsAddon mutation */
    requestUuid: types.union(types.undefined, types.string),
    organizationUuid: types.union(types.undefined, types.string),
    reason: types.union(types.undefined, SmsAddonFailureReasonEnumType),
    errorMessage: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class SmsAddonFailedDtoModelSelector extends QueryBuilder {
  get requestUuid() { return this.__attr(`requestUuid`) }
  get organizationUuid() { return this.__attr(`organizationUuid`) }
  get reason() { return this.__attr(`reason`) }
  get errorMessage() { return this.__attr(`errorMessage`) }
}
export function selectFromSmsAddonFailedDto() {
  return new SmsAddonFailedDtoModelSelector()
}

export const smsAddonFailedDtoModelPrimitives = selectFromSmsAddonFailedDto().requestUuid.organizationUuid.reason.errorMessage
